import { createContext } from 'react'

const defaultValue = { defaultContextValue: true }

const MediaBreakpointContext = createContext(defaultValue)

export default MediaBreakpointContext
